import type { ENVType } from '@/types/ENV'

export default {
  APP_URL: 'http://rbac.alphareds.com/',

  // make sure to end url with a '/'
  API_URL: 'http://localhost:9000/',
  MSAL_TENANT_ID: '7c3a2f70-cbef-4d18-b100-ee3e95b2cba3',
  MSAL_CLIENT_ID: 'b9d130f7-b524-454a-9523-8b95031294e4',
  MSAL_REDIRECT_URI: '/',
  MSAL_POST_LOGOUT_REDIRECT_URI: '/',
  TOKEN_API_URL: 'http://localhost:9000/',
  TOKEN_API_CLIENT_ID: '',
  TOKEN_API_CLIENT_SECRET: '',
  USE_KONG_API: false
} as ENVType
